import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
      <div className="mb-6 text-8xl" aria-hidden>
        🔍
      </div>
      <h1 className="mb-3 text-4xl font-bold text-slate-900">Page not found</h1>
      <p className="mb-8 max-w-md text-slate-500">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="rounded-xl border border-slate-300 px-4 py-2.5 text-sm font-semibold text-slate-700"
        >
          ← Go Back
        </button>
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          className="rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
